export { default, getServerSideProps } from './hae';
